import Navigation from "@/components/landing/Navigation";
import Footer from "@/components/landing/Footer";

const DigitalTherapeutics = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <Navigation />
      <main className="pt-32 pb-16 relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-neutral-900 mb-6">
              Digital Therapeutics
            </h1>
            <p className="text-xl text-neutral-600 mb-8">
              Evidence-based digital interventions designed to prevent, manage, or treat medical disorders and diseases.
            </p>
            
            <div className="prose prose-lg max-w-none">
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Clinical-Grade Digital Solutions</h2>
              <p className="text-neutral-600 mb-6">
                Our digital therapeutics combine medical research, software technology, and personalized care to deliver clinically validated treatment interventions directly through digital platforms.
              </p>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Treatment Areas</h2>
              <ul className="list-disc list-inside text-neutral-600 space-y-2 mb-6">
                <li>Cognitive behavioral therapy programs</li>
                <li>Addiction recovery and substance abuse</li>
                <li>Mental health and mood disorders</li>
                <li>Chronic pain management</li>
                <li>Sleep disorders and insomnia</li>
                <li>Rehabilitation and physical therapy</li>
              </ul>
              
              <h2 className="text-2xl font-semibold text-neutral-800 mb-4">Scientific Validation</h2>
              <p className="text-neutral-600">
                All our digital therapeutic solutions are backed by clinical evidence and regulatory approval, ensuring they meet the same rigorous standards as traditional medical treatments while offering the convenience and accessibility of digital delivery.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default DigitalTherapeutics;